import { type SVGProps } from "react"
import { css } from "@octopus-energy/coral-design/css"

const renewableRepartitionClass = css({
    "& g.rotate-center": {
        animationName: "OEFRRotate",
        animationDuration: "2s",
        animationIterationCount: "infinite",
        animationTimingFunction: "linear",
        transformBox: "fill-box",
        transformOrigin: "28px 26px",
    },
})

export const RenewableRepartition = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="295"
            height="295"
            viewBox="0 0 295 295"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={renewableRepartitionClass}
            {...props}
        >
            <g id="radial">
                <path
                    id="Vector"
                    d="M147.918 292.508C228.032 292.508 292.978 227.562 292.978 147.448C292.978 67.3333 228.032 2.3877 147.918 2.3877C67.8032 2.3877 2.85754 67.3333 2.85754 147.448C2.85754 227.562 67.8032 292.508 147.918 292.508Z"
                    fill="#10C395"
                    fillOpacity="0.2"
                    stroke="#16A88F"
                    strokeWidth="4"
                    strokeMiterlimit="2"
                    strokeLinejoin="round"
                />
                <path
                    id="Vector_2"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M147.918 2.38843C67.8033 2.38843 2.85828 67.3335 2.85828 147.448C2.85828 227.509 67.8573 292.508 147.918 292.508C280.5 292.508 330 136.5 264 61.5L147.918 147.448V2.38843Z"
                    fill="#10C395"
                    fillOpacity="0.1"
                    stroke="#16A88F"
                    strokeWidth="2"
                    strokeMiterlimit="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="4 5"
                />
                <g id="Group 683">
                    <path
                        id="Vector_3"
                        opacity="0.4"
                        d="M178.245 57.5253L176.006 57.5151L175.915 77.6572L178.153 77.6673L178.245 57.5253Z"
                        fill="#18F0B8"
                    />
                    <path
                        id="Vector_4"
                        d="M174.271 36H163.5L168.606 45.4417H179.306L174.271 36Z"
                        fill="#19EEB6"
                    />
                    <path
                        id="Vector_5"
                        d="M175.81 36L180.915 45.4417H189.937L184.902 36H175.81Z"
                        fill="#19EEB6"
                    />
                    <path
                        id="Vector_6"
                        d="M185.181 56.2822L180.076 46.8406H169.375L174.481 56.2822H185.181Z"
                        fill="#19EEB6"
                    />
                    <path
                        id="Vector_7"
                        d="M203.156 67.1223H212.527L207.422 57.6807H198.12L203.156 67.1223Z"
                        fill="#19EEB6"
                    />
                    <path
                        id="Vector_8"
                        d="M197.35 56.2822H206.652L201.547 46.8406H192.245L197.35 56.2822Z"
                        fill="#19EEB6"
                    />
                    <path
                        id="Vector_9"
                        d="M186.72 56.2822H195.742L190.707 46.8406H181.685L186.72 56.2822Z"
                        fill="#19EEB6"
                    />
                    <path
                        id="Vector_10"
                        d="M207.141 77.4731L202.315 68.521H193.293L198.119 77.4731H207.141Z"
                        fill="#19EEB6"
                    />
                    <path
                        id="Vector_11"
                        d="M191.755 68.521H181.125L185.95 77.4731H196.511L191.755 68.521Z"
                        fill="#19EEB6"
                    />
                    <path
                        id="Vector_12"
                        d="M191.545 45.4417H200.777L195.672 36H186.44L191.545 45.4417Z"
                        fill="#19EEB6"
                    />
                    <path
                        id="Vector_13"
                        d="M213.297 68.521H203.925L208.751 77.4731H218.123L213.297 68.521Z"
                        fill="#19EEB6"
                    />
                    <path
                        id="Vector_14"
                        d="M196.51 57.6807H187.488L192.594 67.1223H201.616L196.51 57.6807Z"
                        fill="#19EEB6"
                    />
                    <path
                        id="Vector_15"
                        d="M185.88 57.6807H175.25L180.355 67.1223H190.986L185.88 57.6807Z"
                        fill="#19EEB6"
                    />
                </g>
                <g id="Group 682">
                    <path
                        id="Vector_16"
                        opacity="0.8"
                        d="M107.183 103.363H105.504C105.33 103.359 105.159 103.329 105 103.274C104.842 103.219 104.699 103.141 104.58 103.044C104.461 102.947 104.368 102.833 104.307 102.709C104.246 102.584 104.217 102.452 104.223 102.319L105.107 55.1619C105.095 55.0325 105.118 54.9026 105.174 54.7802C105.231 54.6579 105.32 54.5458 105.436 54.451C105.552 54.3561 105.693 54.2806 105.849 54.229C106.005 54.1775 106.174 54.151 106.344 54.1514C106.516 54.1513 106.686 54.1776 106.845 54.2288C107.003 54.28 107.146 54.355 107.266 54.4493C107.386 54.5436 107.479 54.6553 107.541 54.7777C107.602 54.9002 107.631 55.0308 107.625 55.1619L108.465 102.319C108.456 102.583 108.32 102.834 108.084 103.027C107.848 103.219 107.528 103.339 107.183 103.363Z"
                        fill="#0A604A"
                    />
                    <g className="rotate-center">
                        <path
                            id="Vector_17"
                            opacity="0.8"
                            d="M103.071 47.9208L105.972 52.0689L117.044 27.9381C117.115 27.7836 117.123 27.6099 117.066 27.4503C117.01 27.2906 116.893 27.1561 116.739 27.0724C116.584 26.9992 116.406 26.9808 116.238 27.0205C116.07 27.0602 115.923 27.1554 115.823 27.2889L103.071 45.3959C102.791 45.7639 102.641 46.2054 102.641 46.6584C102.641 47.1114 102.791 47.5529 103.071 47.9208Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_18"
                            opacity="0.8"
                            d="M111.443 52.0768L106.498 52.5048L122.707 73.0455C122.811 73.1656 122.955 73.2457 123.114 73.2717C123.272 73.2978 123.435 73.2682 123.573 73.1881C123.701 73.0901 123.792 72.9525 123.831 72.7972C123.871 72.642 123.856 72.4782 123.79 72.3322L113.682 53.2893C113.47 52.8923 113.145 52.5656 112.747 52.35C112.349 52.1344 111.896 52.0394 111.443 52.0768Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_19"
                            opacity="0.8"
                            d="M104.309 57.5139L106.497 53.033L80.0882 56.3214C80.0033 56.3257 79.9203 56.3473 79.8442 56.3848C79.7681 56.4223 79.7007 56.4748 79.6459 56.5392C79.5912 56.6036 79.5504 56.6784 79.5261 56.759C79.5018 56.8397 79.4944 56.9244 79.5045 57.008C79.5043 57.1744 79.5684 57.3346 79.6838 57.4556C79.7991 57.5766 79.9569 57.6492 80.1246 57.6584L102.084 58.8148C102.543 58.839 102.999 58.7285 103.394 58.4971C103.79 58.2657 104.108 57.9237 104.309 57.5139Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_20"
                            opacity="0.8"
                            d="M106.015 54.9616C107.346 54.9616 108.426 53.8824 108.426 52.5511C108.426 51.2198 107.346 50.1406 106.015 50.1406C104.684 50.1406 103.605 51.2198 103.605 52.5511C103.605 53.8824 104.684 54.9616 106.015 54.9616Z"
                            fill="#0A604A"
                        />
                    </g>
                </g>
                <g id="Group 684">
                    <path
                        id="Vector_21"
                        opacity="0.8"
                        d="M51.1834 161.363H49.5045C49.3304 161.359 49.1591 161.329 49.0005 161.274C48.8418 161.219 48.6989 161.141 48.5799 161.044C48.4609 160.947 48.3682 160.833 48.307 160.709C48.2458 160.584 48.2173 160.452 48.2232 160.319L49.1068 113.162C49.0947 113.032 49.1177 112.903 49.1744 112.78C49.2311 112.658 49.3203 112.546 49.4364 112.451C49.5525 112.356 49.693 112.281 49.8492 112.229C50.0054 112.177 50.1738 112.151 50.344 112.151C50.5161 112.151 50.6863 112.178 50.8447 112.229C51.0031 112.28 51.1464 112.355 51.266 112.449C51.3855 112.544 51.479 112.655 51.5407 112.778C51.6024 112.9 51.6312 113.031 51.6253 113.162L52.4648 160.319C52.4555 160.583 52.32 160.834 52.0839 161.027C51.8479 161.219 51.5275 161.339 51.1834 161.363Z"
                        fill="#0A604A"
                    />
                    <g className="rotate-center">
                        <path
                            id="Vector_22"
                            opacity="0.8"
                            d="M47.0708 105.921L49.9723 110.069L61.0442 85.9381C61.1147 85.7836 61.1226 85.6099 61.0662 85.4503C61.0099 85.2906 60.8934 85.1561 60.7389 85.0724C60.5839 84.9992 60.4064 84.9808 60.2383 85.0205C60.0703 85.0602 59.9227 85.1554 59.8225 85.2889L47.0708 103.396C46.7911 103.764 46.6406 104.205 46.6406 104.658C46.6406 105.111 46.7911 105.553 47.0708 105.921Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_23"
                            opacity="0.8"
                            d="M55.4433 110.077L50.4976 110.505L66.7067 131.045C66.8114 131.166 66.9554 131.246 67.1138 131.272C67.2721 131.298 67.4345 131.268 67.573 131.188C67.7011 131.09 67.7921 130.952 67.8314 130.797C67.8706 130.642 67.856 130.478 67.7897 130.332L57.6815 111.289C57.4703 110.892 57.1453 110.566 56.7473 110.35C56.3492 110.134 55.8957 110.039 55.4433 110.077Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_24"
                            opacity="0.8"
                            d="M48.3088 115.514L50.4974 111.033L24.0882 114.321C24.0033 114.326 23.9203 114.347 23.8442 114.385C23.7681 114.422 23.7007 114.475 23.6459 114.539C23.5912 114.604 23.5504 114.678 23.5261 114.759C23.5018 114.84 23.4944 114.924 23.5045 115.008C23.5043 115.174 23.5684 115.335 23.6838 115.456C23.7991 115.577 23.9569 115.649 24.1246 115.658L46.0837 116.815C46.5427 116.839 46.9986 116.729 47.3944 116.497C47.7903 116.266 48.1083 115.924 48.3088 115.514Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_25"
                            opacity="0.8"
                            d="M50.0152 112.962C51.3465 112.962 52.4257 111.882 52.4257 110.551C52.4257 109.22 51.3465 108.141 50.0152 108.141C48.6839 108.141 47.6047 109.22 47.6047 110.551C47.6047 111.882 48.6839 112.962 50.0152 112.962Z"
                            fill="#0A604A"
                        />
                    </g>
                </g>
                <g id="Group 685">
                    <path
                        id="Vector_26"
                        opacity="0.8"
                        d="M116.183 197.363H114.504C114.33 197.359 114.159 197.329 114 197.274C113.842 197.219 113.699 197.141 113.58 197.044C113.461 196.947 113.368 196.833 113.307 196.709C113.246 196.584 113.217 196.452 113.223 196.319L114.107 149.162C114.095 149.032 114.118 148.903 114.174 148.78C114.231 148.658 114.32 148.546 114.436 148.451C114.552 148.356 114.693 148.281 114.849 148.229C115.005 148.177 115.174 148.151 115.344 148.151C115.516 148.151 115.686 148.178 115.845 148.229C116.003 148.28 116.146 148.355 116.266 148.449C116.386 148.544 116.479 148.655 116.541 148.778C116.602 148.9 116.631 149.031 116.625 149.162L117.465 196.319C117.456 196.583 117.32 196.834 117.084 197.027C116.848 197.219 116.528 197.339 116.183 197.363Z"
                        fill="#0A604A"
                    />
                    <g className="rotate-center">
                        <path
                            id="Vector_27"
                            opacity="0.8"
                            d="M112.071 141.921L114.972 146.069L126.044 121.938C126.115 121.784 126.123 121.61 126.066 121.45C126.01 121.291 125.893 121.156 125.739 121.072C125.584 120.999 125.406 120.981 125.238 121.02C125.07 121.06 124.923 121.155 124.823 121.289L112.071 139.396C111.791 139.764 111.641 140.205 111.641 140.658C111.641 141.111 111.791 141.553 112.071 141.921Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_28"
                            opacity="0.8"
                            d="M120.443 146.077L115.498 146.505L131.707 167.045C131.811 167.166 131.955 167.246 132.114 167.272C132.272 167.298 132.435 167.268 132.573 167.188C132.701 167.09 132.792 166.952 132.831 166.797C132.871 166.642 132.856 166.478 132.79 166.332L122.682 147.289C122.47 146.892 122.145 146.566 121.747 146.35C121.349 146.134 120.896 146.039 120.443 146.077Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_29"
                            opacity="0.8"
                            d="M113.309 151.514L115.497 147.033L89.0882 150.321C89.0033 150.326 88.9203 150.347 88.8442 150.385C88.7681 150.422 88.7007 150.475 88.6459 150.539C88.5912 150.604 88.5504 150.678 88.5261 150.759C88.5018 150.84 88.4944 150.924 88.5045 151.008C88.5043 151.174 88.5684 151.335 88.6838 151.456C88.7991 151.577 88.9569 151.649 89.1246 151.658L111.084 152.815C111.543 152.839 111.999 152.729 112.394 152.497C112.79 152.266 113.108 151.924 113.309 151.514Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_30"
                            opacity="0.8"
                            d="M115.015 148.962C116.346 148.962 117.426 147.882 117.426 146.551C117.426 145.22 116.346 144.141 115.015 144.141C113.684 144.141 112.605 145.22 112.605 146.551C112.605 147.882 113.684 148.962 115.015 148.962Z"
                            fill="#0A604A"
                        />
                    </g>
                </g>
                <g id="Group 686">
                    <path
                        id="Vector_31"
                        opacity="0.8"
                        d="M71.1834 245.363H69.5045C69.3304 245.359 69.1591 245.329 69.0005 245.274C68.8418 245.219 68.6989 245.141 68.5799 245.044C68.4609 244.947 68.3682 244.833 68.307 244.709C68.2458 244.584 68.2173 244.452 68.2232 244.319L69.1068 197.162C69.0947 197.032 69.1177 196.903 69.1744 196.78C69.2311 196.658 69.3203 196.546 69.4364 196.451C69.5525 196.356 69.693 196.281 69.8492 196.229C70.0054 196.177 70.1738 196.151 70.344 196.151C70.5161 196.151 70.6863 196.178 70.8447 196.229C71.0031 196.28 71.1464 196.355 71.266 196.449C71.3855 196.544 71.479 196.655 71.5407 196.778C71.6024 196.9 71.6312 197.031 71.6253 197.162L72.4648 244.319C72.4555 244.583 72.32 244.834 72.0839 245.027C71.8479 245.219 71.5275 245.339 71.1834 245.363Z"
                        fill="#0A604A"
                    />
                    <g className="rotate-center">
                        <path
                            id="Vector_32"
                            opacity="0.8"
                            d="M67.0708 189.921L69.9723 194.069L81.0442 169.938C81.1147 169.784 81.1226 169.61 81.0662 169.45C81.0099 169.291 80.8934 169.156 80.7389 169.072C80.5839 168.999 80.4064 168.981 80.2383 169.02C80.0703 169.06 79.9227 169.155 79.8225 169.289L67.0708 187.396C66.7911 187.764 66.6406 188.205 66.6406 188.658C66.6406 189.111 66.7911 189.553 67.0708 189.921Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_33"
                            opacity="0.8"
                            d="M75.4433 194.077L70.4976 194.505L86.7067 215.045C86.8114 215.166 86.9554 215.246 87.1138 215.272C87.2721 215.298 87.4345 215.268 87.573 215.188C87.7011 215.09 87.7921 214.952 87.8314 214.797C87.8706 214.642 87.856 214.478 87.7897 214.332L77.6815 195.289C77.4703 194.892 77.1453 194.566 76.7473 194.35C76.3492 194.134 75.8957 194.039 75.4433 194.077Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_34"
                            opacity="0.8"
                            d="M68.3088 199.514L70.4974 195.033L44.0882 198.321C44.0033 198.326 43.9203 198.347 43.8442 198.385C43.7681 198.422 43.7007 198.475 43.6459 198.539C43.5912 198.604 43.5504 198.678 43.5261 198.759C43.5018 198.84 43.4944 198.924 43.5045 199.008C43.5043 199.174 43.5684 199.335 43.6838 199.456C43.7991 199.577 43.9569 199.649 44.1246 199.658L66.0837 200.815C66.5427 200.839 66.9986 200.729 67.3944 200.497C67.7903 200.266 68.1083 199.924 68.3088 199.514Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_35"
                            opacity="0.8"
                            d="M70.0152 196.962C71.3465 196.962 72.4257 195.882 72.4257 194.551C72.4257 193.22 71.3465 192.141 70.0152 192.141C68.6839 192.141 67.6047 193.22 67.6047 194.551C67.6047 195.882 68.6839 196.962 70.0152 196.962Z"
                            fill="#0A604A"
                        />
                    </g>
                </g>
                <g id="Group 687">
                    <path
                        id="Vector_36"
                        opacity="0.8"
                        d="M142.183 280.364H140.504C140.33 280.359 140.159 280.329 140 280.274C139.842 280.219 139.699 280.141 139.58 280.044C139.461 279.947 139.368 279.833 139.307 279.709C139.246 279.584 139.217 279.452 139.223 279.319L140.107 232.162C140.095 232.033 140.118 231.903 140.174 231.78C140.231 231.658 140.32 231.546 140.436 231.451C140.552 231.356 140.693 231.281 140.849 231.229C141.005 231.178 141.174 231.151 141.344 231.151C141.516 231.151 141.686 231.178 141.845 231.229C142.003 231.28 142.146 231.355 142.266 231.449C142.386 231.544 142.479 231.655 142.541 231.778C142.602 231.9 142.631 232.031 142.625 232.162L143.465 279.319C143.456 279.583 143.32 279.834 143.084 280.027C142.848 280.219 142.528 280.339 142.183 280.364Z"
                        fill="#0A604A"
                    />
                    <g className="rotate-center">
                        <path
                            id="Vector_37"
                            opacity="0.8"
                            d="M138.071 224.921L140.972 229.069L152.044 204.938C152.115 204.784 152.123 204.61 152.066 204.45C152.01 204.291 151.893 204.156 151.739 204.072C151.584 203.999 151.406 203.981 151.238 204.02C151.07 204.06 150.923 204.155 150.823 204.289L138.071 222.396C137.791 222.764 137.641 223.205 137.641 223.658C137.641 224.111 137.791 224.553 138.071 224.921Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_38"
                            opacity="0.8"
                            d="M146.443 229.077L141.498 229.505L157.707 250.045C157.811 250.165 157.955 250.246 158.114 250.272C158.272 250.298 158.435 250.268 158.573 250.188C158.701 250.09 158.792 249.952 158.831 249.797C158.871 249.642 158.856 249.478 158.79 249.332L148.682 230.289C148.47 229.892 148.145 229.566 147.747 229.35C147.349 229.134 146.896 229.039 146.443 229.077Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_39"
                            opacity="0.8"
                            d="M139.309 234.514L141.497 230.033L115.088 233.321C115.003 233.326 114.92 233.347 114.844 233.385C114.768 233.422 114.701 233.475 114.646 233.539C114.591 233.604 114.55 233.678 114.526 233.759C114.502 233.84 114.494 233.924 114.505 234.008C114.504 234.174 114.568 234.335 114.684 234.456C114.799 234.577 114.957 234.649 115.125 234.658L137.084 235.815C137.543 235.839 137.999 235.729 138.394 235.497C138.79 235.266 139.108 234.924 139.309 234.514Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_40"
                            opacity="0.8"
                            d="M141.015 231.961C142.346 231.961 143.426 230.882 143.426 229.551C143.426 228.22 142.346 227.141 141.015 227.141C139.684 227.141 138.605 228.22 138.605 229.551C138.605 230.882 139.684 231.961 141.015 231.961Z"
                            fill="#0A604A"
                        />
                    </g>
                </g>
                <g id="Group 688">
                    <path
                        id="Vector_41"
                        opacity="0.8"
                        d="M181.183 215.363H179.504C179.33 215.359 179.159 215.329 179 215.274C178.842 215.219 178.699 215.141 178.58 215.044C178.461 214.947 178.368 214.833 178.307 214.709C178.246 214.584 178.217 214.452 178.223 214.319L179.107 167.162C179.095 167.032 179.118 166.903 179.174 166.78C179.231 166.658 179.32 166.546 179.436 166.451C179.552 166.356 179.693 166.281 179.849 166.229C180.005 166.177 180.174 166.151 180.344 166.151C180.516 166.151 180.686 166.178 180.845 166.229C181.003 166.28 181.146 166.355 181.266 166.449C181.386 166.544 181.479 166.655 181.541 166.778C181.602 166.9 181.631 167.031 181.625 167.162L182.465 214.319C182.456 214.583 182.32 214.834 182.084 215.027C181.848 215.219 181.528 215.339 181.183 215.363Z"
                        fill="#0A604A"
                    />
                    <g className="rotate-center">
                        <path
                            id="Vector_42"
                            opacity="0.8"
                            d="M177.071 159.921L179.972 164.069L191.044 139.938C191.115 139.784 191.123 139.61 191.066 139.45C191.01 139.291 190.893 139.156 190.739 139.072C190.584 138.999 190.406 138.981 190.238 139.02C190.07 139.06 189.923 139.155 189.823 139.289L177.071 157.396C176.791 157.764 176.641 158.205 176.641 158.658C176.641 159.111 176.791 159.553 177.071 159.921Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_43"
                            opacity="0.8"
                            d="M185.443 164.077L180.498 164.505L196.707 185.045C196.811 185.166 196.955 185.246 197.114 185.272C197.272 185.298 197.435 185.268 197.573 185.188C197.701 185.09 197.792 184.952 197.831 184.797C197.871 184.642 197.856 184.478 197.79 184.332L187.682 165.289C187.47 164.892 187.145 164.566 186.747 164.35C186.349 164.134 185.896 164.039 185.443 164.077Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_44"
                            opacity="0.8"
                            d="M178.309 169.514L180.497 165.033L154.088 168.321C154.003 168.326 153.92 168.347 153.844 168.385C153.768 168.422 153.701 168.475 153.646 168.539C153.591 168.604 153.55 168.678 153.526 168.759C153.502 168.84 153.494 168.924 153.505 169.008C153.504 169.174 153.568 169.335 153.684 169.456C153.799 169.577 153.957 169.649 154.125 169.658L176.084 170.815C176.543 170.839 176.999 170.729 177.394 170.497C177.79 170.266 178.108 169.924 178.309 169.514Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_45"
                            opacity="0.8"
                            d="M180.015 166.962C181.346 166.962 182.426 165.882 182.426 164.551C182.426 163.22 181.346 162.141 180.015 162.141C178.684 162.141 177.605 163.22 177.605 164.551C177.605 165.882 178.684 166.962 180.015 166.962Z"
                            fill="#0A604A"
                        />
                    </g>
                </g>
                <g id="Group 689">
                    <path
                        id="Vector_46"
                        opacity="0.8"
                        d="M252.183 170.363H250.504C250.33 170.359 250.159 170.329 250 170.274C249.842 170.219 249.699 170.141 249.58 170.044C249.461 169.947 249.368 169.833 249.307 169.709C249.246 169.584 249.217 169.452 249.223 169.319L250.107 122.162C250.095 122.032 250.118 121.903 250.174 121.78C250.231 121.658 250.32 121.546 250.436 121.451C250.552 121.356 250.693 121.281 250.849 121.229C251.005 121.177 251.174 121.151 251.344 121.151C251.516 121.151 251.686 121.178 251.845 121.229C252.003 121.28 252.146 121.355 252.266 121.449C252.386 121.544 252.479 121.655 252.541 121.778C252.602 121.9 252.631 122.031 252.625 122.162L253.465 169.319C253.456 169.583 253.32 169.834 253.084 170.027C252.848 170.219 252.528 170.339 252.183 170.363Z"
                        fill="#0A604A"
                    />
                    <g className="rotate-center">
                        <path
                            id="Vector_47"
                            opacity="0.8"
                            d="M248.071 114.921L250.972 119.069L262.044 94.9381C262.115 94.7836 262.123 94.6099 262.066 94.4503C262.01 94.2906 261.893 94.1561 261.739 94.0724C261.584 93.9992 261.406 93.9808 261.238 94.0205C261.07 94.0602 260.923 94.1554 260.823 94.2889L248.071 112.396C247.791 112.764 247.641 113.205 247.641 113.658C247.641 114.111 247.791 114.553 248.071 114.921Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_48"
                            opacity="0.8"
                            d="M256.443 119.077L251.498 119.505L267.707 140.045C267.811 140.166 267.955 140.246 268.114 140.272C268.272 140.298 268.435 140.268 268.573 140.188C268.701 140.09 268.792 139.952 268.831 139.797C268.871 139.642 268.856 139.478 268.79 139.332L258.682 120.289C258.47 119.892 258.145 119.566 257.747 119.35C257.349 119.134 256.896 119.039 256.443 119.077Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_49"
                            opacity="0.8"
                            d="M249.309 124.514L251.497 120.033L225.088 123.321C225.003 123.326 224.92 123.347 224.844 123.385C224.768 123.422 224.701 123.475 224.646 123.539C224.591 123.604 224.55 123.678 224.526 123.759C224.502 123.84 224.494 123.924 224.505 124.008C224.504 124.174 224.568 124.335 224.684 124.456C224.799 124.577 224.957 124.649 225.125 124.658L247.084 125.815C247.543 125.839 247.999 125.729 248.394 125.497C248.79 125.266 249.108 124.924 249.309 124.514Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_50"
                            opacity="0.8"
                            d="M251.015 121.962C252.346 121.962 253.426 120.882 253.426 119.551C253.426 118.22 252.346 117.141 251.015 117.141C249.684 117.141 248.605 118.22 248.605 119.551C248.605 120.882 249.684 121.962 251.015 121.962Z"
                            fill="#0A604A"
                        />
                    </g>
                </g>
                <g id="Group 690">
                    <path
                        id="Vector_51"
                        opacity="0.8"
                        d="M227.183 248.363H225.504C225.33 248.359 225.159 248.329 225 248.274C224.842 248.219 224.699 248.141 224.58 248.044C224.461 247.947 224.368 247.833 224.307 247.709C224.246 247.584 224.217 247.452 224.223 247.319L225.107 200.162C225.095 200.032 225.118 199.903 225.174 199.78C225.231 199.658 225.32 199.546 225.436 199.451C225.552 199.356 225.693 199.281 225.849 199.229C226.005 199.177 226.174 199.151 226.344 199.151C226.516 199.151 226.686 199.178 226.845 199.229C227.003 199.28 227.146 199.355 227.266 199.449C227.386 199.544 227.479 199.655 227.541 199.778C227.602 199.9 227.631 200.031 227.625 200.162L228.465 247.319C228.456 247.583 228.32 247.834 228.084 248.027C227.848 248.219 227.528 248.339 227.183 248.363Z"
                        fill="#0A604A"
                    />
                    <g className="rotate-center">
                        <path
                            id="Vector_52"
                            opacity="0.8"
                            d="M223.071 192.921L225.972 197.069L237.044 172.938C237.115 172.784 237.123 172.61 237.066 172.45C237.01 172.291 236.893 172.156 236.739 172.072C236.584 171.999 236.406 171.981 236.238 172.02C236.07 172.06 235.923 172.155 235.823 172.289L223.071 190.396C222.791 190.764 222.641 191.205 222.641 191.658C222.641 192.111 222.791 192.553 223.071 192.921Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_53"
                            opacity="0.8"
                            d="M231.443 197.077L226.498 197.505L242.707 218.045C242.811 218.166 242.955 218.246 243.114 218.272C243.272 218.298 243.435 218.268 243.573 218.188C243.701 218.09 243.792 217.952 243.831 217.797C243.871 217.642 243.856 217.478 243.79 217.332L233.682 198.289C233.47 197.892 233.145 197.566 232.747 197.35C232.349 197.134 231.896 197.039 231.443 197.077Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_54"
                            opacity="0.8"
                            d="M224.309 202.514L226.497 198.033L200.088 201.321C200.003 201.326 199.92 201.347 199.844 201.385C199.768 201.422 199.701 201.475 199.646 201.539C199.591 201.604 199.55 201.678 199.526 201.759C199.502 201.84 199.494 201.924 199.505 202.008C199.504 202.174 199.568 202.335 199.684 202.456C199.799 202.577 199.957 202.649 200.125 202.658L222.084 203.815C222.543 203.839 222.999 203.729 223.394 203.497C223.79 203.266 224.108 202.924 224.309 202.514Z"
                            fill="#19EEB6"
                        />
                        <path
                            id="Vector_55"
                            opacity="0.8"
                            d="M226.015 199.962C227.346 199.962 228.426 198.882 228.426 197.551C228.426 196.22 227.346 195.141 226.015 195.141C224.684 195.141 223.605 196.22 223.605 197.551C223.605 198.882 224.684 199.962 226.015 199.962Z"
                            fill="#0A604A"
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}
